/** @type {import('../help-index.js').HelpScreen} */
export const SETTINGS_PASSKEYS_HELP = {
  screenId: 'settings-passkeys',
  label: 'Registrar biometría',
  navPath: 'Configuración (ruedita) → Registrar biometría',
  keywords: ['webauthn', 'huella', 'face id', 'biometría', 'passkey', 'login'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Vincular huella o reconocimiento facial para iniciar sesión sin contraseña.',
  sidebarItems: [{
    id: 'passkeys',
    screenId: 'settings-passkeys',
    label: 'Dispositivos biométricos',
    description: 'Registrar o quitar dispositivos de acceso.',
    detail: {
      sections: [
        {
          title: 'Para qué sirve',
          intro: 'Podés entrar al sistema con huella o rostro en lugar de escribir la contraseña cada vez. Cada dispositivo (celular, notebook, etc.) se registra por separado.',
        },
        {
          title: 'Antes de empezar',
          bullets: [
            'Tu navegador debe soportar biometría (WebAuthn).',
            'La opción «Registrar biometría» solo aparece si el dispositivo lo permite.',
            'Necesitás estar logueado con usuario y contraseña para registrar un dispositivo nuevo.',
          ],
        },
        {
          title: 'Paso 1 — Abrir la ventana',
          steps: [
            'Tocá el ícono de configuración (ruedita) arriba a la derecha.',
            'Elegí «Registrar biometría».',
          ],
        },
        {
          title: 'Paso 2 — Registrar este dispositivo',
          steps: [
            'Tocá «Registrar este dispositivo».',
            'El sistema pedirá confirmación biométrica del navegador o del sistema operativo.',
            'Al terminar, el dispositivo aparece en la lista con nombre y fecha de registro.',
          ],
        },
        {
          title: 'Paso 3 — Administrar dispositivos',
          bullets: [
            'Cada fila muestra nombre del dispositivo, fecha de alta y último uso si aplica.',
            '«Eliminar» quita ese dispositivo; ya no podrás usarlo para ingresar.',
            'Podés tener varios dispositivos registrados a la vez.',
          ],
        },
        {
          title: 'Iniciar sesión con biometría',
          paragraphs: [
            'En la pantalla de login, después de elegir cliente y usuario, usá la opción de ingreso biométrico si está disponible.',
          ],
        },
      ],
    },
  }],
}
